<div class="container"  style="width: 20%;">
    <H1>Add User</H1>
  
    <div>
      <div class="form-group">
        <label>Username:</label>
        <input class="form-control" name="Username" type="text" [(ngModel)]="Username" required
          placeholder="Enter Username" maxlength="20" minlength="6"/>
      </div>
  
  
      <div class="form-group">
        <label>Password:</label>
        <input class="form-control" name="Password" type="password" [(ngModel)]="Password" required
          placeholder="Enter Password" maxlength="10" minlength="6"/>
      </div>

      <div class="form-group">
        <label>Confirm Password:</label>
        <input class="form-control" name="ConfirmPassword" type="password" [(ngModel)]="ConfirmPassword" required
          placeholder="Confirm Password" maxlength="10" minlength="6"/>
      </div>

      <div class="form-group">
        <label>Rights:</label>
          <select class="form-control" name="Rights" type="text" [(ngModel)]="Rights" required
          placeholder="Enter Rights">
              <option value="Admin">Admin</option>
              <option value="Manager">Manager</option>
              <option value="User">User</option>
          </select>
      </div>
  
  
      <div class="form-group" style="display: inline-flex;">
  
          <div style="float: left;margin-right: 20px;">
              <button class="btn btn-primary btn-lg btn-block" type="submit"  (click)="Back()">Back</button>
          </div>
  
  
          <div style="float: left;margin-right: 20px;margin-left:20px;">
              <button class="btn btn-warning btn-lg btn-block" type="submit"  (click)="Reset()">Reset</button>
          </div>
  
          <div style="float: right;margin-left:20px;">
              <button class="btn btn-success btn-lg btn-block" type="submit" [disabled]="!Username || !Password ||!Rights ||!ConfirmPassword " (click)="Save()">Save</button>
          </div>

      </div>

    </div>
  
  </div>


  
  <div style="float: right;margin-left:20px;">
    <button class="btn btn-success btn-lg btn-block" id="ErrorButton" (click)="open(content)" style="display: none;">
    </button>
  </div>
   <ng-template #content let-modal ID="Errormessage">
        <div class="modal-header">
            <h4 class="modal-title" 
                id="modal-basic-title">
                {{PopupTitle}}
            </h4>
            <button type="button" class="close"
                    aria-label="Close" (click)=
                    "modal.dismiss('Cross click')">
      
                <span aria-hidden="true">
                    ×
                </span>
            </button>
        </div>
        <div class="modal-body">
            <form>
                <div class="form-group">
                    <label for="dateOfBirth">
                        {{DisplayErrormessage}}
                    </label>
                </div>
            </form>
        </div>
        <div class="modal-footer">
            <button type="button" 
                class="btn btn-success btn-lg btn-block" 
                (click)="modal.close('Save click')">
                Done
            </button>
        </div>
    </ng-template>
